import { render, staticRenderFns } from "./VolunteerBackendComponent.vue?vue&type=template&id=12746e8d&scoped=true&"
import script from "./VolunteerBackendComponent.vue?vue&type=script&lang=js&"
export * from "./VolunteerBackendComponent.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerBackendComponent.vue?vue&type=style&index=0&id=12746e8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12746e8d",
  null
  
)

export default component.exports